export const carouselImage = [
    { image: "https://www.ryans.com/storage/sliders/mobile/02-Main-Slide2_1711338787.webp" },
    { image: "https://www.startech.com.bd/image/cache/catalog/home/banner/desktop-deal-ramadan-home-banner-982x500.png" },
    { image: "https://img.freepik.com/free-photo/workplace-business-modern-male-accessories-laptop-white_155003-1722.jpg" },


]